export interface ParamRow {
  name: string;
  type: string;
  required?: boolean;
  description: string;
  default?: string;
  example?: string;
}

interface ParamTableProps {
  title: string;
  params: ParamRow[];
}

export function ParamTable({ title, params }: ParamTableProps) {
  if (params.length === 0) return null;

  return (
    <div className="space-y-2">
      <h4 className="text-sm font-semibold text-base-content">{title}</h4>
      <div className="overflow-x-auto rounded-lg border border-base-content/10">
        <table className="table table-xs w-full">
          <thead>
            <tr className="bg-base-200/60">
              <th className="text-base-content/60 font-medium">Name</th>
              <th className="text-base-content/60 font-medium">Type</th>
              <th className="text-base-content/60 font-medium">Description</th>
              <th className="text-base-content/60 font-medium">Default</th>
            </tr>
          </thead>
          <tbody>
            {params.map((param) => (
              <tr key={param.name} className="border-base-content/5">
                <td className="font-mono text-xs whitespace-nowrap">
                  {param.name}
                  {param.required && (
                    <span className="text-red-400 ml-0.5" title="Required">
                      *
                    </span>
                  )}
                </td>
                <td className="text-xs text-base-content/60 font-mono whitespace-nowrap">
                  {param.type}
                </td>
                <td className="text-xs text-base-content/80">
                  {param.description}
                </td>
                <td className="text-xs text-base-content/40 font-mono">
                  {param.default ?? "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
